module.exports = __webpack_public_path__ + "static/media/bg-default.108e95e3.png";